import { HttpClient } from '@angular/common/http';
import { Component, inject, type OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import * as BillingCancelPost from '../../../server/routes/billing/cancel/post';
import { generatePath } from '../../../server/services/utils.service';

@Component({
  selector: 'app-billing-cancel-dialog',
  templateUrl: './billing-cancel-dialog.component.html',
  styleUrls: ['./billing-cancel-dialog.component.scss'],
  standalone: false,
})
export class BillingCancelDialogComponent implements OnDestroy {
  private dialogRef = inject(MatDialogRef<BillingCancelDialogComponent>);
  private readonly data: { orgId: string } = inject(MAT_DIALOG_DATA);
  private http = inject(HttpClient);

  orgId: string;
  state: 'ready' | 'waiting' | 'success' | 'error' = 'ready';
  subscriptions = new Subscription();

  constructor() {
    this.orgId = this.data.orgId;
    const sub = this.dialogRef.beforeClosed().subscribe(() => {
      //
    });
    this.subscriptions.add(sub);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancelSubscription() {
    const body: BillingCancelPost.ReqBody = {};
    const path = generatePath<BillingCancelPost.ReqParams>(
      '/api/orgs/:orgId/billing/cancel',
      { orgId: this.orgId }
    );
    this.state = 'waiting';
    this.http.post<BillingCancelPost.ResBody>(path, body).subscribe({
      next: () => {
        this.state = 'success';
        this.dialogRef.close({ cancelled: true });
      },
      error: (err) => {
        console.error(err);
        this.state = 'error';
      },
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
